import React, { useState, SyntheticEvent, FunctionComponent } from "react";
import { Choice } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers/intlHooks";
import { LowIncomeSubsidyAmount } from "../../@types";
import { NoIconAlert } from "../../components";

interface ExtraSSHelpProps {
  updateAmountOfSSHelp: (value: LowIncomeSubsidyAmount | null) => void;
}

const ExtraSSHelp: FunctionComponent<ExtraSSHelpProps> = ({
  updateAmountOfSSHelp,
}) => {
  const t = useTranslate();
  const [getsPartialHelp, setGetsPartialHelp] = useState(false);

  const handleFirstChoice = (e: SyntheticEvent<HTMLInputElement>): void => {
    if (e.currentTarget.value === "full") {
      setGetsPartialHelp(false);
      updateAmountOfSSHelp(LowIncomeSubsidyAmount.HelpNA);
    } else {
      setGetsPartialHelp(true);
      updateAmountOfSSHelp(null);
    }
  };

  const firstChoices = [
    { label: t("landing_page.lis.ss_full_amount_of_help"), value: "full" },
    {
      label: t("landing_page.lis.ss_partial_amount_of_help"),
      value: "partial",
    },
    {
      label: t("landing_page.lis.ss_partial_help_option_unsure"),
      value: "full",
      checkedDescription: t("landing_page.lis.ss_unsure_help_description"),
    },
  ];

  const secondChoices = [
    {
      label: t("landing_page.lis.ss_partial_help_option_0"),
      value: LowIncomeSubsidyAmount.Help0,
    },
    {
      label: t("landing_page.lis.ss_partial_help_option_25"),
      value: LowIncomeSubsidyAmount.Help25,
    },
    {
      label: t("landing_page.lis.ss_partial_help_option_50"),
      value: LowIncomeSubsidyAmount.Help50,
    },
    {
      label: t("landing_page.lis.ss_partial_help_option_75"),
      value: LowIncomeSubsidyAmount.Help75,
    },
    {
      label: t("landing_page.lis.ss_partial_help_option_unsure"),
      value: LowIncomeSubsidyAmount.HelpUnsure,
      checkedDescription: t("landing_page.lis.ss_partial_help_option_unsure"),
    },
  ];

  const handleSecondChoice = (e: SyntheticEvent<HTMLInputElement>): void => {
    updateAmountOfSSHelp(e.currentTarget.value as LowIncomeSubsidyAmount);
  };

  return (
    <>
      <legend className="ds-text-heading--xl ds-u-margin--0 ds-u-margin-top--5 ds-u-margin-bottom--1 ds-u-padding--0">
        <h3>{t("landing_page.lis.ss_how_much_help")}</h3>
      </legend>
      {firstChoices.map(choice => {
        return (
          <Choice
            name="sshelpFirstChoice"
            key={choice.label}
            type="radio"
            value={choice.value}
            onChange={handleFirstChoice}
            checkedChildren={
              choice.checkedDescription
                ? NoIconAlert(
                    "",
                    t("landing_page.lis.ss_unsure_help_description")
                  )
                : ""
            }
          >
            {choice.label}
          </Choice>
        );
      })}

      {getsPartialHelp && (
        <>
          <div className="subChoices">
            <legend className="ds-text-heading--xl ds-u-margin--0 ds-u-margin-top--5 ds-u-margin-bottom--1 ds-u-padding--0">
              <div className="ds-c-label mct-l-h3">
                {t("landing_page.lis.ss_what_percentage_of_premium")}
              </div>
            </legend>
            {secondChoices.map(choice => {
              return (
                <Choice
                  name="sshelpSecondChoice"
                  key={choice.value}
                  type="radio"
                  value={choice.value}
                  onChange={handleSecondChoice}
                  checkedChildren={
                    choice.checkedDescription
                      ? NoIconAlert(
                          "",
                          t("landing_page.lis.ss_unsure_help_description")
                        )
                      : ""
                  }
                >
                  {choice.label}
                </Choice>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default ExtraSSHelp;
